/* eslint-disable arrow-body-style */

import _ from 'underscore';

export const getContactDecoratorStyles = ({ styleOverrides }) => () => {
  return {
    container: _.extend({
      display: 'flex',
      gap: '8px',
      alignItems: 'center',
      marginTop: '8px',
    }, styleOverrides.phoneAndAddressDecoratorContainer),
    section: _.extend({
      display: 'flex',
      alignItems: 'center',
      gap: '4px',
    }, styleOverrides.phoneAndAddressDecoratorSection),
    addressLabel: _.extend({
      fontSize: '13px',
      lineHeight: '16px',
      color: '#001BA0',
    }, styleOverrides.phoneAndAddressDecoratorAddressLabel),
    phoneLabel: _.extend({
      fontSize: '13px',
      lineHeight: '16px',
      color: '#605e5c',
    }, styleOverrides.phoneAndAddressDecoratorPhoneLabel),
    icon: _.extend({
      display: 'inline-block',
      height: '16px',
      width: '16px',
      verticalAlign: 'text-top',
    }, styleOverrides.phoneAndAddressDecoratorIcon),
  };
};
